(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.mql = window.matchMedia('(min-width: 750px)');
    this.setupAccessibility();
    this.openMenuOnClick();
  }
  connectedCallback() {
    this.mql.addEventListener('change', this.resizeListener);
  }
  resizeListener = () => {
    this.setupAccessibility();
    this.openMenuOnClick();
  }
  setupAccessibility() {
    if (this.mql.matches) {
      this.querySelectorAll(':scope > details > summary').forEach(summary => {
        summary.removeAttribute('aria-expanded');
      });
      return;
    }
    const summary = this.querySelector(':scope > details > summary');
    const details = this.querySelector('details');
    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', (details && details.open));
    });
  }
  openMenuOnClick() {
    const summary = this.querySelector(':scope > details > summary');
    if (!summary) return;
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const details = this.querySelector('details');
      if (details) {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      }
    });
  }
}if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', HeaderDrawer);
}
  } catch(e) { console.error(e); }
})();

})();
